import React from 'react';
import { Form, Select, Input } from 'antd';
import filterConnect from '../../../../../../common/hoc/filterConnect';
const Option = Select.Option;

class OtherUserInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { isEditable, form, foreignLanguages, filterOption } = this.props; // validateField,
    const { getFieldDecorator } = form;

    return (
      <div className="b-form-fields">
        <div className="b-form-fields__item">
          <Form.Item label="Знание иностранных языков">
            {getFieldDecorator('foreignLanguages', {
              rules: [],
            })(
              <Select
                mode="multiple"
                style={{ width: 224 }}
                name="foreignLanguages"
                placeholder="Укажите знания ин. языка"
                filterOption={filterOption}
                disabled={!isEditable}
                getPopupContainer={trigger => trigger.parentNode}
              >
                {foreignLanguages &&
                  foreignLanguages.map(item => {
                    return (
                      <Option
                        key={item.foreignLanguageKey}
                        value={item.foreignLanguageKey}
                      >
                        {item.foreignLanguage}
                      </Option>
                    );
                  })}
              </Select>
            )}
          </Form.Item>
        </div>
        <div className="b-form-fields__item">
          <Form.Item label="Использование очков">
            {getFieldDecorator('glassesNeed', {
              rules: [],
            })(
              <Select
                style={{ width: 224 }}
                placeholder="Использование очков"
                disabled={!isEditable}
                getPopupContainer={trigger => trigger.parentNode}
              >
                <Option value="1">Да</Option>
                <Option value="0">Нет</Option>
              </Select>
            )}
          </Form.Item>
        </div>
        <div className="b-form-fields__item">
          <Form.Item
            label={
              <span className="label-multiline">
                Иное ограничение <br />
                из строки 14 ВУ
              </span>
            }
          >
            {getFieldDecorator('additionalInformation', {
              rules: [],
            })(
              <Input
                style={{ width: 224 }}
                placeholder="Укажите ограничение"
                disabled={!isEditable}
              />
            )}
          </Form.Item>
        </div>
      </div>
    );
  }
}

export default filterConnect(OtherUserInfo, ['foreignLanguages']);
